import { Box } from "@material-ui/core";
import { memo } from "react";

// ----------------------------------------------------------------------

function TareasAnualesIlustracion({ ...other }) {
  return (
    <Box {...other}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        width="100%"
        height="100%"
        viewBox="0 0 3400 3400"
      >
        <path
          fill="#F4F7FA"
          d="M2536.756 2465.789c-74.083 76.363-140.371 121.252-191.123 155.14-494.974 330.499-1060.782 235.241-1235.718 202.682-282.234-52.529-520.479-89.587-725.175-274.521-465.13-420.227-442.507-1296.849-87.091-1839.879 42.142-64.388 397.02-590.426 964.054-664.549 13.869-1.813 24.217-2.845 33.279-3.805 87.72-9.287 631.296-58.305 1074.528 313.036 63.446 53.155 165.551 149.034 260.233 295.265 346.207 534.686 347.305 1362.797-92.987 1816.631z"
        />
        <defs>
          <path
            id="a"
            d="m1335.708 2382.08 248.563 169.785s133.887-95.547 134.439-227.141c1.127-268.49 236.201-248.764 335.896-255.23 150.348-9.753 278.586-83.917 167.331-230.333s186.004-270.788 431.084-251.544c239.827 18.832 411.691-396.624-103.645-485.043-307.757-52.804-440.822 220.841-540.872 343.055-100.05 122.214-300.635.967-342.919 204.867-36.118 174.168 3.688 346.344-141.895 383.604-145.582 37.259-225.442 135.981-187.982 347.98z"
          />
        </defs>
        <clipPath id="b">
          <use xlinkHref="#a" overflow="visible" />
        </clipPath>
        <linearGradient
          id="c"
          x1={6529.789}
          x2={5930.494}
          y1={-215.12}
          y2={1488.141}
          gradientTransform="rotate(34.335 2298.38 -5584.523)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#c)"
          d="m1335.708 2382.08 248.563 169.785s133.887-95.547 134.439-227.141c1.127-268.49 236.201-248.764 335.896-255.23 150.348-9.753 261.191-79.331 187.27-224.072-83.638-163.769 166.065-277.049 411.146-257.805 239.827 18.832 411.691-396.624-103.645-485.043-307.757-52.804-440.822 220.841-540.872 343.055-100.05 122.214-300.635.967-342.919 204.867-36.118 174.168 3.688 346.344-141.895 383.604-145.583 37.259-225.443 135.981-187.983 347.98z"
          clipPath="url(#b)"
        />
        <g fill="#BEB8F2" clipPath="url(#b)" opacity={0.5}>
          <path d="m1427.528 2478.633 5.808 2.58c1.598-3.598 162.853-363.158 430.188-671.403 246.286-283.978 635.628-581.241 1091.814-384.736l2.515-5.836c-203.072-87.476-409.999-86.072-615.034 4.169-163.787 72.088-326.689 200.724-484.181 382.336-267.926 308.964-429.507 669.286-431.11 672.89z" />
          <path d="m2258.77 1464.816 5.652 2.907c96.808-188.051 330.999-389.139 333.353-391.149l-4.123-4.835c-2.365 2.02-237.507 203.924-334.882 393.077zm138.262-56.382c251.819 10.604 380.787 176.143 382.059 177.813l5.054-3.849c-1.289-1.698-131.938-169.578-386.844-180.313l-.269 6.349zm-697.303 612.418c227.662-207.324 605.592-38.159 609.136-36.203l3.425-5.346c-3.297-2.249-387.155-172.315-616.838 36.851l4.277 4.698zm69.987-105.94 5.871 2.441c75.465-181.417-22.184-408.416-23.181-410.689l-5.819 2.549c.984 2.25 97.546 226.817 23.129 405.699zm-309.76 510.279c73.342-91.125 262.904-73.464 264.81-73.277l.628-6.32c-7.92-.789-194.884-18.201-270.388 75.614l4.95 3.983zm37.042-85.661 5.777 2.649c38.568-84.062-17.94-245.654-36.51-298.755-2.624-7.505-4.889-13.981-5.065-15.216l-6.303.811c.224 1.743 1.717 6.054 5.369 16.503 18.361 52.502 74.233 212.275 36.732 294.008z" />
        </g>
        <linearGradient
          id="d"
          x1={-2397.814}
          x2={-1643.294}
          y1={302.742}
          y2={2285.307}
          gradientTransform="scale(-1 1) rotate(12.703 -644.038 2280.172)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#d)"
          d="M1961.897 1498.404c55.929 59.144 44.434 137.242 27.262 192.454-7.518 2.157-11.293 5.315-18.37 9.161-63.884 34.711-98.534 35.906-166.902 60.178-14.717 5.225-62.574 7.422-82.186 7.064l-36.553-1.25s-111.084-150.869-32.715-223.165c78.37-72.296-8.954-228.967-44.986-317.667-22.126-54.469-14.797-86.467-19.714-107.787-52.052-225.678-138.219-271.76-110.064-355.545 31.081-92.492 144.986-62.807 184.112-161.637 44.181-111.598-71.397-224.375-5.989-320.64 11.214-16.504 23.186-33.157 45.586-47.532 55.293-35.483 114.785-14.658 143.345-77.089 57.403-125.491 190.086-201.983 308.049-122.551 116.422 78.396 76.788 310.662-128.113 545.935-126.642 183.93-116.584 225.524-72.346 321.27 30.982 67.065 159.418 228.369 79.506 329.622-79.912 101.254-133.861 201.567-69.922 269.179z"
        />
        <defs>
          <path
            id="e"
            d="m1962.105 1759.732-269.464 10.793s-118.577-155.382-40.208-227.678c78.37-72.297-8.954-228.968-44.985-317.668-97.766-240.668 197.845-299.307 99.025-618.28-26.283-84.836-107.132-238.026-50.682-327.328 64.313-101.74 152.202-44.333 188.93-124.623 57.403-125.49 190.087-201.982 308.049-122.55 116.423 78.396 76.788 310.663-128.111 545.934-126.643 183.932-116.584 225.524-72.348 321.27 30.985 67.065 159.418 228.37 79.507 329.623-79.912 101.252-133.859 201.565-69.922 269.179 97.289 102.881.209 261.328.209 261.328z"
          />
        </defs>
        <clipPath id="f">
          <use xlinkHref="#e" overflow="visible" />
        </clipPath>
        <g fill="#FCFDFE" clipPath="url(#f)" opacity={0.5}>
          <path d="m1841.047 1752.584-5.279.844a3347.952 3347.952 0 0 1-13.628-87.42c-30.424-214.017-38.162-423.236-22.994-621.854 12.854-168.294 42.292-331.346 87.499-484.628 36.354-123.269 83.06-240.917 138.816-349.676 39.198-76.455 82.429-147.763 128.497-211.938 8.025-11.185 16.901-22.217 25.486-32.886 11.437-14.214 23.264-28.913 33.167-44.088l4.559 2.52c-10.04 15.384-21.945 30.182-33.459 44.494-8.542 10.616-17.373 21.593-25.318 32.665-45.924 63.973-89.026 135.067-128.112 211.307-55.62 108.489-102.211 225.858-138.483 348.842-45.113 152.966-74.492 315.694-87.32 483.663-15.144 198.282-7.416 407.169 22.963 620.854a3322.56 3322.56 0 0 0 13.606 87.301z" />
          <path d="m1845.08 749.215-5.278-.707c36.358-210.573-151.724-527.93-153.629-531.109l4.682-2.46c1.914 3.196 190.874 322.017 154.225 534.276zm-46.168 596.513-5.339-.132c6.7-145.523 242.882-322.724 245.267-324.497l3.305 3.85c-2.367 1.758-236.639 177.53-243.233 320.779zm3.89 82.761-5.295.743c-13.798-93.949-86.855-214.443-205.714-339.278-5.977-6.278-5.977-6.278-6.127-7.206l5.287-.805-2.643.402 2.294-1.284c.346.461 2.602 2.831 5.219 5.578 119.536 125.549 193.044 246.952 206.979 341.85zm30.056 270.854-5.278-.688c17.437-103.651 162.413-183.336 163.873-184.129l2.645 4.269c-1.441.781-144.202 79.27-161.24 180.548zm.538 55.79c-43.84-73.311-112.009-137.01-208.4-194.738l2.95-4.179c97.131 58.173 165.866 122.437 210.134 196.461l-4.684 2.456zm165.17-1478.675-5.22-.981c27.232-116.133 26.914-243.571 26.81-285.447-.025-10.137-.021-13.706.212-14.952l5.264.778c-.164.953-.15 6.748-.131 14.085.104 42.01.423 169.854-26.935 286.517zm-74.29 183.188-4.654-2.369c58.867-97.604 289.844-159.87 299.648-162.474l1.394 4.765c-2.378.633-238.62 64.298-296.388 160.078z" />
        </g>
        <linearGradient
          id="g"
          x1={2996.894}
          x2={4012.652}
          y1={151.576}
          y2={1823.776}
          gradientTransform="scale(-1 1) rotate(6.684 -1470.321 -46115.936)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ff9085",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#fb6fbb",
            }}
          />
        </linearGradient>
        <path
          fill="url(#g)"
          d="M1961.971 2278.165c-18.487-.154-8.145-96.692-75.368-210.752-16.795-28.496-97.617-190.272-233.127-179.092l-78.914 6.508c-29.503-56.176-46.9-114.587 29.913-146.531 119.29-49.606 95.023-255.628 51.401-324.375-53.988-85.088-175.39-285.649 7.75-365.078 152.462-66.126 265.17-79.394 250.712-273.564-14.457-194.172 81.15-327.665 268.032-338.08 196.666-10.959 324.135-274.848 494.811-211.767 297.392 109.921 101.473 564.712-220.854 727.819-322.324 163.106-112.797 255.317-82.734 412.065 1.967 14.708 3.881 37.665.996 65.188-17.76 169.45-186.681 218.271-293.91 367.984-146.241 204.177-87.563 469.936-118.708 469.675z"
        />
        <defs>
          <path
            id="h"
            d="m2020.621 1892.378-425.448 47.028c-31.84-54.088-76.501-155.426 9.301-191.107 119.292-49.608 95.024-255.628 51.403-324.376-53.989-85.087-175.39-285.649 7.75-365.079 152.462-66.125 265.168-79.392 250.711-273.563s81.151-327.665 268.033-338.079c196.664-10.959 324.133-274.85 494.809-211.766 297.394 109.919 101.474 564.709-220.852 727.817-322.326 163.107-112.799 255.317-82.735 412.066 41.044 213.996-273.772 204.406-344.093 298.682-55.127 73.906-31.124 164.075-8.879 218.377z"
          />
        </defs>
        <clipPath id="i">
          <use xlinkHref="#h" overflow="visible" />
        </clipPath>
        <g fill="#FCFDFE" clipPath="url(#i)" opacity={0.5}>
          <path d="m1812.456 1851.375-9.255-.678c52.719-638.399 433.537-1249.529 993.846-1594.899l5.075 7.333c-557.946 343.915-937.166 952.497-989.666 1588.244z" />
          <path d="m1872.797 1505.641-9.215 1.06c-32.195-249.809-283.938-418.524-286.479-420.199l5.319-7.179c2.574 1.693 257.671 172.571 290.375 426.318zm-47.249 228.545-8.642-3.197c98.719-237.517 582.337-325.025 587.211-325.881l1.699 8.611c-4.821.846-483.427 87.467-580.268 320.467zm304.763-807.226-8.902-2.486c60.98-194.042-103.068-463.034-104.731-465.729l8.017-4.414c1.684 2.727 167.725 275.003 105.616 472.629zm256.112-327.08-5.783-6.854c191.249-143.592 519.927-114.105 523.229-113.787l-.933 8.715c-3.26-.317-328.246-29.431-516.513 111.926z" />
        </g>
        <linearGradient
          id="j"
          x1={627.307}
          x2={2250.864}
          y1={1587.416}
          y2={1587.416}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#aa80f9",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#6165d7",
            }}
          />
        </linearGradient>
        <path
          fill="url(#j)"
          d="M2250.864 2614.25 627.307 2731.086V443.745l1623.557 61.883z"
        />
        <linearGradient
          id="k"
          x1={2279.285}
          x2={1119.155}
          y1={1253.025}
          y2={1582.252}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#fff",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f4f7fa",
            }}
          />
        </linearGradient>
        <path
          fill="url(#k)"
          d="M2375.919 2535.816 774.376 2645.12V369.879l1601.543 71.081z"
        />
        <path
          fill="#D8DEE8"
          d="m1717.737 2588.738-932.534 73.452-6.285-2276.02 576.042 14.7c-112.636 206.881-235.884 389.615 157.169 776.929 399.466 393.632 559.606 995.408 205.608 1410.939z"
          opacity={0.2}
        />
        <linearGradient
          id="l"
          x1={1087.92}
          x2={1314.275}
          y1={890.21}
          y2={890.21}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ff9085",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#fb6fbb",
            }}
          />
        </linearGradient>
        <path
          fill="url(#l)"
          d="m1313.729 1011.124-225.809 2.424.673-246.675 225.682.029z"
          opacity={0.6}
        />
        <linearGradient
          id="m"
          x1={1386.102}
          x2={2180.25}
          y1={827.095}
          y2={827.095}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.004}
            style={{
              stopColor: "#e38ddd",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#9571f6",
            }}
          />
        </linearGradient>
        <path
          fill="url(#m)"
          d="m2180.209 883.493-794.106 4.825.252-121.764 793.895-.683z"
          opacity={0.3}
        />
        <linearGradient
          id="n"
          x1={1086.563}
          x2={1313.175}
          y1={1385.377}
          y2={1385.377}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ff9085",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#fb6fbb",
            }}
          />
        </linearGradient>
        <path
          fill="url(#n)"
          d="m1312.628 1504.059-226.065 7.384.673-247.211 225.939-4.92z"
          opacity={0.6}
        />
        <linearGradient
          id="o"
          x1={1385.082}
          x2={2180.086}
          y1={1310.008}
          y2={1310.008}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.004}
            style={{
              stopColor: "#e38ddd",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#9571f6",
            }}
          />
        </linearGradient>
        <path
          fill="url(#o)"
          d="m2180.046 1358.159-794.964 21.563.254-122.025 794.75-17.404z"
          opacity={0.3}
        />
        <linearGradient
          id="p"
          x1={1085.202}
          x2={1312.072}
          y1={1881.602}
          y2={1881.602}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ff9085",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#fb6fbb",
            }}
          />
        </linearGradient>
        <path
          fill="url(#p)"
          d="m1311.524 1998.055-226.322 12.366.676-247.749 226.194-9.891z"
          opacity={0.6}
        />
        <linearGradient
          id="q"
          x1={1384.06}
          x2={2179.923}
          y1={1793.939}
          y2={1793.939}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.004}
            style={{
              stopColor: "#e38ddd",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#9571f6",
            }}
          />
        </linearGradient>
        <path
          fill="url(#q)"
          d="m2179.883 1833.809-795.823 38.372.253-122.288 795.61-34.194z"
          opacity={0.3}
        />
        <linearGradient
          id="r"
          x1={2169.318}
          x2={-665.698}
          y1={3199.008}
          y2={2021.754}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#311944",
            }}
          />
          <stop
            offset={0.267}
            style={{
              stopColor: "#371b47",
            }}
          />
          <stop
            offset={0.48}
            style={{
              stopColor: "#462150",
            }}
          />
          <stop
            offset={0.719}
            style={{
              stopColor: "#612a5f",
            }}
          />
          <stop
            offset={0.974}
            style={{
              stopColor: "#853774",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#893976",
            }}
          />
        </linearGradient>
        <path
          fill="url(#r)"
          d="M687.987 2666.652c23.986 12.179 54.123.996 67.311-24.978s4.433-56.902-19.556-69.081c-1.243-.632-2.512-1.161-3.783-1.669 4.456-14.372 7.816-28.856 10.07-43.347 1.374-.004 2.755-.027 4.156-.151 27.368-2.44 49.088-27.587 48.516-56.173-.573-28.583-23.224-49.777-50.591-47.338-1.431.129-2.836.354-4.233.603a279.035 279.035 0 0 0-11.716-41.395c1.258-.737 2.511-1.498 3.734-2.354 23.414-16.403 30.899-48.78 16.721-72.315-14.181-23.533-44.657-29.313-68.07-12.909-1.201.841-2.329 1.749-3.444 2.67a247.45 247.45 0 0 0-30.365-28.345c.771-1.265 1.526-2.546 2.21-3.891 13.188-25.974 30.42-54.347 6.243-66.148-55.924-27.302-79.923-3.931-93.11 22.043-.682 1.347-1.271 2.712-1.837 4.081a247.36 247.36 0 0 0-40.802-7.788c.086-1.444.151-2.892.122-4.356-.572-28.582 7.908-44.051-19.563-44.584-59.904-1.165-80.116 24.836-79.543 53.419.03 1.493.155 2.953.303 4.405a278.88 278.88 0 0 0-40.334 14.967c-.622-1.275-1.27-2.542-2.012-3.772-14.179-23.534-44.655-29.314-68.069-12.909-23.416 16.404-30.9 48.78-16.72 72.315.726 1.205 1.521 2.332 2.33 3.445-10.369 10.369-20.08 21.63-29.054 33.708-1.16-.727-2.338-1.438-3.579-2.069-23.988-12.18-54.124-.995-67.312 24.978s-4.433 56.902 19.555 69.082c1.243.63 2.513 1.161 3.783 1.668-4.456 14.372-7.816 28.855-10.069 43.347-1.375.004-2.755.026-4.156.151-27.368 2.44-49.088 27.588-48.516 56.172s23.224 49.776 50.591 47.338c1.431-.128 2.836-.353 4.232-.603a278.815 278.815 0 0 0 11.717 41.395c-1.257.737-2.511 1.498-3.734 2.355-23.414 16.404-30.9 48.78-16.721 72.314 14.181 23.534 61.126 34.468 84.54 18.063 1.2-.84-14.14-6.902-13.025-7.823a247.138 247.138 0 0 0 30.365 28.344c-.771 1.265-1.527 2.548-2.21 3.892-13.188 25.975-4.432 56.903 19.556 69.082 23.987 12.18 54.124.996 67.311-24.978.684-1.345 1.271-2.712 1.838-4.081a247.24 247.24 0 0 0 40.802 7.789c-.086 1.444-.152 2.891-.123 4.356.573 28.583 23.224 49.776 50.592 47.337 27.367-2.44 49.088-27.589 48.515-56.171-.03-1.494-.155-2.955-.304-4.405a278.685 278.685 0 0 0 40.334-14.969c.623 1.275 1.271 2.543 2.012 3.772 14.181 23.534 44.655 29.314 68.07 12.909 23.415-16.404 30.9-48.78 16.721-72.315-.727-1.204-1.521-2.332-2.331-3.444 10.369-10.37 20.08-21.63 29.054-33.709 1.158.729 2.335 1.439 3.578 2.07zm-299.027 3.795c-87.094-44.221-118.883-156.515-71.003-250.819 47.881-94.305 157.299-134.905 244.392-90.687 87.095 44.219 118.882 156.514 71.002 250.818-47.881 94.304-157.298 134.907-244.391 90.688z"
        />
        <linearGradient
          id="s"
          x1={2170.163}
          x2={-664.862}
          y1={3196.979}
          y2={2019.721}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.1}
            style={{
              stopColor: "#311944",
            }}
          />
          <stop
            offset={0.267}
            style={{
              stopColor: "#371b47",
            }}
          />
          <stop
            offset={0.48}
            style={{
              stopColor: "#462150",
            }}
          />
          <stop
            offset={0.719}
            style={{
              stopColor: "#612a5f",
            }}
          />
          <stop
            offset={0.974}
            style={{
              stopColor: "#853774",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#893976",
            }}
          />
        </linearGradient>
        <path
          fill="url(#s)"
          d="M746.186 2527.427c27.368-2.44 49.088-27.589 48.516-56.173-.573-28.583-23.224-49.777-50.592-47.338-1.43.128-2.835.354-4.231.603a279.09 279.09 0 0 0-11.717-41.395c1.258-.735 2.511-1.498 3.734-2.355 23.414-16.402 52.382-56.04 35.862-77.994-31.353-41.669-63.799-23.633-87.212-7.229-1.201.841-2.329 1.748-3.444 2.67a247.295 247.295 0 0 0-30.365-28.345c.771-1.265 1.526-2.546 2.21-3.891 7.178-14.137 7.81-29.722 3.069-42.972-22.614 39.805-44.926 79.775-66.837 119.965 69.481 50.913 91.602 151.248 48.171 236.787-36.803 72.487-109.96 113.189-181.392 108.089-3.186 8.264-6.314 16.571-9.727 24.757-9.261 22.208-19.779 43.96-30.313 65.684a246.084 246.084 0 0 0 19.95 2.932c-.087 1.444-.153 2.891-.124 4.355.573 28.584 17.928 52.868 67.527 50.237 27.438-1.454 32.152-30.488 31.579-59.071-.03-1.493-.155-2.954-.304-4.405a278.915 278.915 0 0 0 40.334-14.968c.623 1.275 1.271 2.543 2.012 3.771 14.181 23.536 63.373 33.534 86.788 17.129 23.414-16.404 12.183-52.999-1.997-76.534-.727-1.205-1.521-2.332-2.331-3.445 10.369-10.369 20.081-21.63 29.054-33.708 1.16.729 2.336 1.44 3.58 2.069 23.986 12.181 54.123.997 67.311-24.978 13.188-25.973 4.433-56.901-19.556-69.08-1.243-.632-2.511-1.161-3.783-1.669 4.456-14.372 7.816-28.856 10.07-43.345 1.375-.006 2.756-.029 4.158-.153z"
        />
        <linearGradient
          id="t"
          x1={-597.927}
          x2={1458.663}
          y1={1814.23}
          y2={3102.002}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#aa80f9",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#6165d7",
            }}
          />
        </linearGradient>
        <path
          fill="url(#t)"
          d="M713.786 2669.587c23.987 12.179 54.124.995 67.312-24.978 13.188-25.974 4.433-56.903-19.556-69.082-1.243-.631-2.511-1.16-3.783-1.668 4.456-14.373 7.817-28.857 10.07-43.347 1.375-.004 2.755-.027 4.156-.153 27.367-2.438 49.088-27.588 48.516-56.171s-23.224-49.777-50.59-47.338c-1.433.129-2.837.354-4.234.603a278.933 278.933 0 0 0-11.716-41.395c1.258-.737 2.511-1.498 3.735-2.355 23.413-16.402 30.898-48.781 16.72-72.314-14.181-23.533-44.657-29.314-68.07-12.91-1.201.842-2.329 1.748-3.444 2.67a247.364 247.364 0 0 0-30.365-28.344c.771-1.266 1.526-2.547 2.21-3.893 13.188-25.974 4.432-56.902-19.557-69.081-23.986-12.179-54.122-.996-67.311 24.978-.683 1.345-1.271 2.712-1.838 4.081a247.102 247.102 0 0 0-40.801-7.788c.086-1.444.151-2.893.123-4.356-.573-28.583-23.223-49.776-50.591-47.338-27.368 2.44-49.089 27.589-48.517 56.172.031 1.493.156 2.954.304 4.405a278.898 278.898 0 0 0-40.333 14.967c-.623-1.274-1.271-2.541-2.011-3.771-14.181-23.535-44.657-29.314-68.072-12.909s-30.899 48.78-16.719 72.313c.726 1.207 1.521 2.334 2.329 3.445-10.368 10.371-20.079 21.631-29.053 33.71-1.16-.729-2.336-1.438-3.579-2.07-23.988-12.179-54.124-.996-67.312 24.978s-4.433 56.902 19.555 69.081c1.243.632 2.513 1.161 3.783 1.669-4.456 14.373-7.816 28.856-10.068 43.346-1.376.006-2.756.027-4.157.152-27.368 2.439-49.088 27.589-48.516 56.172.572 28.584 23.224 49.777 50.591 47.337 1.431-.128 2.836-.351 4.232-.601a278.731 278.731 0 0 0 11.718 41.395c-1.259.736-2.512 1.498-3.735 2.355-23.414 16.402-30.9 48.78-16.72 72.314 14.179 23.533 44.655 29.313 68.07 12.91 1.199-.842 2.329-1.749 3.443-2.67a247.514 247.514 0 0 0 30.365 28.344c-.771 1.265-1.527 2.546-2.21 3.892-13.187 25.974-4.432 56.903 19.556 69.081 23.987 12.179 54.124.996 67.311-24.977.683-1.346 1.271-2.712 1.838-4.081a247.133 247.133 0 0 0 40.802 7.788c-.086 1.445-.152 2.892-.123 4.356.573 28.582 23.224 49.776 50.593 47.337 27.366-2.439 49.088-27.588 48.514-56.17-.03-1.494-.155-2.955-.304-4.406a279.033 279.033 0 0 0 40.334-14.968c.623 1.274 1.271 2.542 2.012 3.771 14.181 23.534 44.656 29.315 68.07 12.91 23.415-16.405 30.9-48.78 16.722-72.315-.728-1.205-1.522-2.332-2.332-3.444 10.369-10.37 20.081-21.63 29.054-33.709 1.16.727 2.337 1.438 3.579 2.07zm-299.026 3.793c-87.095-44.219-118.883-156.513-71.001-250.817 47.879-94.305 157.297-134.907 244.39-90.688 87.094 44.219 118.882 156.514 71.002 250.818-47.881 94.305-157.298 134.907-244.391 90.687z"
        />
        <linearGradient
          id="u"
          x1={-1185.022}
          x2={-406.538}
          y1={1454.542}
          y2={1983.323}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#311944",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#6b3976",
            }}
          />
        </linearGradient>
        <path
          fill="url(#u)"
          d="M645.635 1735.811c14.645-9.495 1.301-37.116.512-96.445-.966-72.704 18.344-86.252 2.834-114.776-18.964-34.88-66.705-49.313-98.334-49.994-6.976-.149-8.606-3.959-67.049 11.176-105.291 27.269-131.648-1.962-178.801 27.236-45.554 28.213-25.605 59.109-69.843 92.194-71.704 53.629-147.108-4.35-198.355 40.509-48.473 42.431-49.589 150.536 1.396 209.531 57.801 66.881 162.023 46.787 231.88 33.525 14.698-2.789 88.935-18.38 166.229-75.43 42.76-31.562 72.118-65.265 90.797-90.099 4.384-4.934 11.225-10.911 20.255-11.873 10.841-1.158 19.55 5.474 23.747 8.38 22.036 15.261 60.345 25.392 74.732 16.066z"
        />
        <linearGradient
          id="v"
          x1={704.188}
          x2={724.273}
          y1={1762.412}
          y2={2085.216}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ff9085",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#fb6fbb",
            }}
          />
        </linearGradient>
        <path
          fill="url(#v)"
          d="M822.235 1940.44c-1.937-5.837-2.307-10.579-1.142-14.245a334.388 334.388 0 0 1-9.787-13.032c-45.658-64.049-41.637-105.85-93.955-157.406-44.534-43.883-111.731-76.947-130.562-59.792-23.538 21.446 32.363 117.823 74.433 190.352 41.918 72.269 63.74 108.967 106.156 136.665 25.089 16.383 50.915 26.224 74.954 32.005-3.443-38.676-13.487-76.32-20.097-114.547z"
        />
        <linearGradient
          id="w"
          x1={-1529.31}
          x2={-1424.467}
          y1={2676.588}
          y2={2676.588}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#311944",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#6b3976",
            }}
          />
        </linearGradient>
        <path
          fill="url(#w)"
          d="m1011.202 2676.557-52.456-31.519h-23.675s-8.064 30.019-7.149 31.519c10.548 17.284 59.658 30.434 90.304 31.521 5.089.181 12.188.208 14.023-3.48 3.107-6.246-10.773-19.347-21.047-28.041z"
        />
        <linearGradient
          id="x"
          x1={-1479.865}
          x2={-1323.448}
          y1={2717.906}
          y2={2248.655}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#x)"
          d="M957.816 2610.643c-3.371 19.514.895 29.687 5.491 35.385 3.236 4.012 6.11 5.152 25.317 21.754 6.351 5.492 9.582 8.433 8.848 9.972-.839 1.76-6.444.806-18.548-2.104-26.376-6.344-39.631-9.645-42.867-15.992-2.93-5.748-.34-8.34-.51-24-.111-10.311-2.208-18.61-3.856-23.802 8.709-.406 17.416-.809 26.125-1.213z"
        />
        <linearGradient
          id="y"
          x1={-1512.622}
          x2={-1448.503}
          y1={2484.082}
          y2={2484.082}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#311944",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#6b3976",
            }}
          />
        </linearGradient>
        <path
          fill="url(#y)"
          d="M995.737 2455.996s23.699 28.279 19.843 59.28c-3.856 30.999-45.361-14.323-51.147-29.642-5.788-15.316-12.547-37.14-12.547-37.14s29.104-18.105 43.851 7.502z"
        />
        <linearGradient
          id="z"
          x1={-1549.783}
          x2={-1445.083}
          y1={2660.141}
          y2={2346.041}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#z)"
          d="M986.696 2411.749s-6.43 32.945 5.834 50.333c6.107 8.66 14.346 16.006 11.923 23.056-1.623 4.725-7.788 8.119-13.01 7.583-9.997-1.027-15.539-16.354-19.448-27.164-5.773-15.967-8.992-50.134-8.992-50.134l23.693-3.674z"
        />
        <linearGradient
          id="A"
          x1={-1420.774}
          x2={-1342.682}
          y1={2130.958}
          y2={2582.43}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ab316d",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#792d3d",
            }}
          />
        </linearGradient>
        <path
          fill="url(#A)"
          d="M967.808 2439.521c7.289-2.654 14.577-5.31 21.865-7.965 11.37-25.971 25.248-68.627 20.612-120.475-11.92-133.336-135.241-203.992-148.941-211.555-33.599 16.858-67.632 40.641-68.864 70.622-1.547 37.636 49.724 57.53 97.92 112.563 28.93 33.035 59.842 82.257 77.408 156.81z"
        />
        <linearGradient
          id="B"
          x1={-1310.489}
          x2={-1199.451}
          y1={2666.019}
          y2={2314.602}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ab316d",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#792d3d",
            }}
          />
        </linearGradient>
        <path
          fill="url(#B)"
          d="M959.951 2625.894c24.081-94.071 17.93-170.837 10.982-215.06-10.501-66.84-31.857-202.8-122.631-253.497-19.821-11.071-48.159-20.985-82.697-51.765-28.842-25.703-47.173-52.736-58.235-71.781-121.398-35.611-233.371-21.18-282.781 43.928-5.709 7.523-20.003 23.842-22.768 47.903-6.239 54.289 47.104 119.648 106.961 133.297 76.073 17.347 120.206-60.765 187.605-34.775 18.854 7.269 34.838 25.284 66.807 61.314 40.669 45.834 63.529 88.128 72.179 105.052 25.754 50.394 45.284 87.595 48.133 135.807.663 11.232 1.06 33.924 14.216 58.396 10.098 18.786 23.786 31.312 33.97 39.051 9.419.709 18.839 1.421 28.259 2.13z"
        />
        <linearGradient
          id="C"
          x1={-1310.478}
          x2={-1199.44}
          y1={2666.023}
          y2={2314.606}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ab316d",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#792d3d",
            }}
          />
        </linearGradient>
        <path
          fill="url(#C)"
          d="M401.821 2125.622c2.765-24.062 17.059-40.38 22.768-47.903 49.41-65.107 161.383-79.539 282.781-43.928 11.063 19.045 29.394 46.078 58.234 71.781 34.539 30.779 62.877 40.693 82.698 51.765 55.43 30.958 84.95 93.7 101.946 153.092-25.218-39.1-46.804-49.494-63.509-49.68-23.911-.266-34.595 20.179-63.146 17.388-30.516-2.982-37.493-28.216-62.229-31.114-7.404-.868-16.514.274-27.456 6.1-14.602-15.289-25.485-24.339-37.521-28.979-67.399-25.989-111.532 52.122-187.605 34.775-59.857-13.648-113.2-79.008-106.961-133.297z"
          opacity={0.3}
        />
        <linearGradient
          id="D"
          x1={-1154.233}
          x2={-1076.32}
          y1={2085.392}
          y2={2535.825}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ab316d",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#792d3d",
            }}
          />
        </linearGradient>
        <path
          fill="url(#D)"
          d="M897.052 2199.412a399.914 399.914 0 0 0-60.424 1.369c-121.13 11.971-154.521 71.887-254.633 86.507-23.683 3.46-129.125 18.859-174.795-42.097-32.787-43.763-27.826-119.17 8.036-148.828 15.178-12.552 30.204-12.203 127.406-11.324 36.606.332 73.214.45 109.818.917 154.951 1.975 184.584-8.757 212.778 16.872 13.153 11.956 32.385 37.636 31.814 96.584z"
        />
        <linearGradient
          id="E"
          x1={-1266.877}
          x2={-574.769}
          y1={1805.741}
          y2={2059.19}
          gradientTransform="matrix(-1 0 0 1 -496.617 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ff9085",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#fb6fbb",
            }}
          />
        </linearGradient>
        <path
          fill="url(#E)"
          d="M569.934 1702.252s-180.813-52.731-199.571 79.642c-17.979 126.875 74.123 185.099 32.217 313.61-4.857 14.896 344.195-53.34 344.195-53.34-46.594-58.129-57.423-106.085-58.535-139.429-1.221-36.556 9.316-53.171 0-96.384 0 0-10.396-48.217-47.897-89.62-5.385-5.943-11.803-12.133-70.409-14.479z"
        />
        <linearGradient
          id="F"
          x1={2460.736}
          x2={2468.693}
          y1={1564.27}
          y2={1352.332}
          gradientTransform="rotate(10.276 235.478 -9038.461)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#F)"
          d="M530.664 1622.921c1.656 7.739 10.088 49.265-6.902 59.949-3.683 2.317-10.759 3.642-24.913 6.295a344.416 344.416 0 0 1-22.524 3.458c.792 6.963 3.138 18.297 11.174 28.606 22.526 28.901 67.694 21.423 74.136 20.249 22.72-4.137 45.076-11.157 50.476-15.447 8.221-6.532 14.685-11.434 18.508-16.413-8.793-4.249-26.543-15.454-38.455-19.12a220.852 220.852 0 0 0-24.861-6.097c-1.248-8.021-2.5-16.043-3.748-24.065a275357.528 275357.528 0 0 1-32.891-37.415z"
        />
        <linearGradient
          id="G"
          x1={2458.252}
          x2={2454.846}
          y1={1377.171}
          y2={1651.572}
          gradientTransform="rotate(10.276 235.478 -9038.461)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#G)"
          d="M529.868 1643.616s3.07 30.431 32.652 35.794c26.486 4.802 46.424-59.203 32.869-75.758-4.521-5.523-15.684-10.777-25.36-10.498-6.806.196-29.794 8.951-33.001 31.952-4.579-4.823-10.283-6.21-13.096-4.19-3.567 2.563-1.657 10.012-1.223 11.699 1.502 5.848 5.319 9.473 7.159 11.001z"
        />
        <linearGradient
          id="H"
          x1={4987.498}
          x2={5195.001}
          y1={-2822.037}
          y2={-2616.195}
          gradientTransform="matrix(-.0003 1.0058 -.9942 -.1144 -1941.953 -3473.13)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#40447e",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#3c3b6b",
            }}
          />
        </linearGradient>
        <path
          fill="url(#H)"
          d="m863.217 1789.651-7.137 286.763c-.212 8.485-6.08 15.602-15.442 18.729l-190.455 63.624c-15.032 5.021-30.406-6.658-29.599-22.486l13.721-269.018c.423-8.287 6.137-15.236 15.196-18.479l195.074-69.82c8.303-2.973 18.832 3.063 18.642 10.687z"
        />
        <linearGradient
          id="I"
          x1={5010.441}
          x2={5201.489}
          y1={-2799.279}
          y2={-2609.759}
          gradientTransform="matrix(-.0003 1.0058 -.9942 -.1144 -1941.953 -3473.13)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#40447e",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#3c3b6b",
            }}
          />
        </linearGradient>
        <path
          fill="url(#I)"
          d="M840.638 2095.145c9.362-3.129 15.23-10.245 15.442-18.73l.155-6.284c-11.746-2.291-22.49-6.376-31.163-13.055-27.08-20.849-10.365-48.387-39.021-73.644-31.479-27.744-68.967-9.773-98.265-34.712-30.836-26.249-5.713-60.065-25.438-104.532l-12.847 4.598c-9.061 3.242-14.774 10.191-15.197 18.479l-13.865 271.855c-.738 14.465 13.312 25.138 27.049 20.549l193.15-64.524z"
          opacity={0.3}
        />
        <linearGradient
          id="J"
          x1={-797.868}
          x2={-778.632}
          y1={1203.779}
          y2={1512.929}
          gradientTransform="rotate(-17.767 1747.889 -2152.27) scale(1.0001)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ff9085",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#fb6fbb",
            }}
          />
        </linearGradient>
        <path
          fill="url(#J)"
          d="m576.111 2047.348 5.105-30.084c-41.167-3.043-98.301-8.259-157.604-17.182-9.289-1.398-20.354-3.215-25.525-11.685-14.55-23.828 36.492-62.975 52.962-122.667 17.706-64.174-6.836-145.026-33.64-149.451-54.106-8.933-205.517 278.999-118.247 364.694 48.076 47.207 163.997 28.543 276.949-33.625z"
        />
        <linearGradient
          id="K"
          x1={-564.308}
          x2={-664.86}
          y1={1571.326}
          y2={1666.083}
          gradientTransform="rotate(-11.098 2273.95 -4414.06)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#K)"
          d="M581.218 2017.264c21.966-17.843 53.944-10.252 56.012-9.729 5.888 1.485 14.62 4.478 24.133 11.016 1.136 1.047 14.668 13.699 11.72 19.184-2.363 4.394-15.009 3.618-31.233-2.535a114.453 114.453 0 0 0-26.017 4.448c-19.489 5.728-27.352 13.783-35.619 9.785-6.055-2.926-9.498-10.951-8.821-17.553.724-7.092 6.106-11.596 9.825-14.616z"
        />
        <linearGradient
          id="L"
          x1={2637.637}
          x2={2575.193}
          y1={2150.273}
          y2={2209.119}
          gradientTransform="scale(-1 1) rotate(-11.104 -95.263 19963.846)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#L)"
          d="M861.346 1948.924c-8.841-2.123-24.063 11.726-23.825 26.973.201 12.814 11.312 25.861 20.445 24.753 5.736-.696 9.286-6.804 10.572-9.019 8.845-15.22 3.079-40.24-7.192-42.707z"
        />
        <linearGradient
          id="M"
          x1={-550.359}
          x2={-1369.408}
          y1={2306.696}
          y2={2596.775}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#aa80f9",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#6165d7",
            }}
          />
        </linearGradient>
        <path
          fill="url(#M)"
          d="m2331.445 2759.159-330.563 53.864a87.453 87.453 0 0 1-20.929.867l-27.004-2.127 4.478-587.576 374.018-13.276v548.248z"
        />
        <linearGradient
          id="N"
          x1={-644.585}
          x2={-891.034}
          y1={2551.438}
          y2={2479.399}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#aa80f9",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#6165d7",
            }}
          />
        </linearGradient>
        <path
          fill="url(#N)"
          d="M1574.562 2245.805v511.742c0 18.311 14.065 33.27 32.259 34.352l356.896 21.229c14.437.858 26.755-11.13 26.755-26.011v-533.146c0-14.892-11.677-27.24-26.168-27.644l-359.468-10.018c-16.673-.464-30.274 12.771-30.274 29.496z"
        />
        <linearGradient
          id="O"
          x1={-901.644}
          x2={-964.792}
          y1={2028.738}
          y2={2251.257}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#aa80f9",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#6165d7",
            }}
          />
        </linearGradient>
        <path
          fill="url(#O)"
          d="m2331.445 2210.911-340.974 16.146-385.636-10.747 395.368-12.881z"
        />
        <linearGradient
          id="P"
          x1={1574.562}
          x2={1915.94}
          y1={2508.621}
          y2={2508.621}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#aa80f9",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#6165d7",
            }}
          />
        </linearGradient>
        <path
          fill="url(#P)"
          d="m1605.344 2216.324 281.523 7.844c16.015.446 29.091 13.955 29.073 30.317-.03 27.307-4.585 55.529-16.605 82.757-40.075 90.775-129.659 94.127-148.299 177.447-15.53 69.423 39.464 99.291 45.276 188.003 1.527 23.305-.489 48.374-7.428 75.252-3.651 14.147-16.806 23.784-31.145 22.932l-154.987-9.22c-15.901-.945-28.191-14.015-28.191-30.012v-515.329c.001-17.005 13.831-30.463 30.783-29.991z"
        />
        <linearGradient
          id="Q"
          x1={-835.136}
          x2={-673.291}
          y1={2261.92}
          y2={3077.253}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#Q)"
          d="m1865.374 2807.278-132.324-7.871v-579.524l132.324 3.687z"
        />
        <linearGradient
          id="R"
          x1={-810.599}
          x2={-523.927}
          y1={2515.604}
          y2={2473.209}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#R)"
          d="m1859.414 2806.924-126.364-7.517v-579.524l126.364 3.52z"
        />
        <linearGradient
          id="S"
          x1={-1003.282}
          x2={-395.049}
          y1={2225.941}
          y2={2135.992}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#S)"
          d="m2098.988 2205.66-368.873 20.974h132.618l322.501-19.026z"
        />
        <linearGradient
          id="T"
          x1={-694.983}
          x2={-845.685}
          y1={2055.948}
          y2={2212.677}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#T)"
          d="M1919.497 2196.484c-8.59-52.62-14.867-91.076-49.229-126.589-14.489-14.976-30.313-31.329-56.262-35.666-29.841-4.988-67.93 6.773-78.364 31.145-9.909 23.141 13.435 38.221 3.516 64.802-9.967 26.714-39.014 26.145-42.196 47.722-2.694 18.275 15.146 39.011 33.154 48.728 31.103 16.779 48.762-6.828 109.51-3.015 41.862 2.628 66.023 15.881 77.36 2.512 5.397-6.365 4.868-15.203 2.511-29.639z"
        />
        <g opacity={0.3}>
          <linearGradient
            id="U"
            x1={-670.716}
            x2={-821.417}
            y1={2079.283}
            y2={2236.013}
            gradientTransform="matrix(-1 0 0 1 1014.031 0)"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#ffc444",
              }}
            />
            <stop
              offset={0.314}
              style={{
                stopColor: "#fba94a",
              }}
            />
            <stop
              offset={0.996}
              style={{
                stopColor: "#f36f56",
              }}
            />
          </linearGradient>
          <path
            fill="url(#U)"
            d="M1753.224 2175.889c37.506-14.345 56.729-45.563 73.341-38.178 14.764 6.563 5.756 33.962 23.107 56.262 15.846 20.364 44.908 25.208 70.732 25.229-.651 2.606-1.712 4.908-3.419 6.921-11.337 13.369-35.498.116-77.36-2.512-60.748-3.813-78.407 19.794-109.51 3.015-16.522-8.915-32.855-27.102-33.365-44.156 17.527 1.882 37.023.858 56.474-6.581z"
          />
        </g>
        <linearGradient
          id="V"
          x1={-1051.069}
          x2={-650.834}
          y1={2118.426}
          y2={2059.236}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#V)"
          d="M2146.052 2066.379c-25.229-19.912-51.826 2.293-82.886-19.592-31.46-22.166-22.319-57.731-46.718-67.815-28.345-11.716-70.33 24.032-90.421 46.718-51.031 57.623-74.996 159.924-34.661 195.912 15.139 13.507 58.007 7.94 143.125-3.743 97.29-13.354 111.291-22.92 120.604-35.439 25.091-33.739 19.519-93.499-9.043-116.041z"
        />
        <g opacity={0.3}>
          <linearGradient
            id="W"
            x1={-1046.413}
            x2={-646.178}
            y1={2149.91}
            y2={2090.72}
            gradientTransform="matrix(-1 0 0 1 1014.031 0)"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#ffc444",
              }}
            />
            <stop
              offset={0.314}
              style={{
                stopColor: "#fba94a",
              }}
            />
            <stop
              offset={0.996}
              style={{
                stopColor: "#f36f56",
              }}
            />
          </linearGradient>
          <path
            fill="url(#W)"
            d="M1986.309 2109.58c14.021-4.423 20.408 11.623 49.229 18.084 5.289 1.186 56.113 11.804 83.389-20.094 10.821-12.655 15.9-29.676 15.311-47.723 3.979 1.383 7.914 3.452 11.815 6.531 28.563 22.542 34.134 82.302 9.043 116.04-9.313 12.52-23.313 22.085-120.604 35.439-85.118 11.684-127.986 17.25-143.125 3.743-2.034-1.815-3.862-3.842-5.574-5.98 20.421-.673 41.846-5.617 57.315-20.644 29.847-28.992 19.366-77.878 43.201-85.396z"
          />
        </g>
        <linearGradient
          id="X"
          x1={-3501.879}
          x2={-3262.377}
          y1={-737.842}
          y2={-737.842}
          gradientTransform="scale(-1 1) rotate(-31.714 9.174 -855.588)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ff9085",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#fb6fbb",
            }}
          />
        </linearGradient>
        <path
          fill="url(#X)"
          d="m2753.664 897.047-67.769 144.283s144.955 91.751 194.119 76.426c49.165-15.325 70.177-44.156-126.35-220.709z"
        />
        <path
          fill="#FFF"
          d="M2633.359 1103.604c-1.065-3.053-57.623 60.169-192.258 65.112 0 0 112.814 201.736 155.907 209.624 43.094 7.888 109.625-64.629 36.351-274.736z"
        />
        <linearGradient
          id="Y"
          x1={-3080.364}
          x2={-2953.231}
          y1={231.368}
          y2={-653.676}
          gradientTransform="scale(-1 1) rotate(-31.714 9.174 -855.588)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#aa80f9",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#6165d7",
            }}
          />
        </linearGradient>
        <path
          fill="url(#Y)"
          d="M2401.529 1172.364c-4.513 5.574-107.549 219.493-158.163 267.514-50.615 48.021-72.997-75.545-78.038-139.489s6.954-184.527 6.954-184.527l229.247 56.502z"
        />
        <linearGradient
          id="Z"
          x1={-1547.76}
          x2={-1541.24}
          y1={-274.866}
          y2={-718.224}
          gradientTransform="scale(-1 1) rotate(-31.714 9.174 -855.588)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#Z)"
          d="M1123.467 564.565S967.293 697.476 907.365 694.877s-47.202-284.746-47.202-284.746l263.304 154.434z"
        />
        <linearGradient
          id="aa"
          x1={-1304.041}
          x2={-1176.908}
          y1={486.493}
          y2={-398.552}
          gradientTransform="scale(-1 1) rotate(-31.714 9.174 -855.588)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ff9085",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#fb6fbb",
            }}
          />
        </linearGradient>
        <path
          fill="url(#aa)"
          d="M813.995 395.678c8.036 4.625-87.307 154.146-162.479 186.318-75.174 32.171-123.997-260.909-123.997-260.909s166.177 5.358 286.476 74.591z"
        />
        <linearGradient
          id="ab"
          x1={-1106.619}
          x2={-830.932}
          y1={65.784}
          y2={65.784}
          gradientTransform="scale(-1 1) rotate(-31.714 9.174 -855.588)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#aa80f9",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#6165d7",
            }}
          />
        </linearGradient>
        <path
          fill="url(#ab)"
          d="M402.067 325.642s15.425 219.832-3.908 280.653c-19.333 60.822-158.816-117.398-242.051-131.129 0 0 65.241-117.554 245.959-149.524z"
        />
        <linearGradient
          id="ac"
          x1={-994.362}
          x2={-539.611}
          y1={542.921}
          y2={-718.645}
          gradientTransform="scale(-1 1) rotate(-31.714 9.174 -855.588)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#ac)"
          d="m68.368 617.057-25.4 149.096s117.783 23.044 154.051 24.979c36.266 1.934 57.1-72.058-128.651-174.075z"
        />
        <path
          fill="#B2B8C1"
          d="M262.646 363.379c90.034-47.479 189.375-65.28 290.307-54.1 100.662 11.15 197.521 44.656 289.668 85.545 96.581 42.856 189.115 94.31 281.202 145.947 123.553 69.283 245.826 140.79 367.839 212.743 61.503 36.269 122.958 72.62 184.531 108.771 61.188 35.924 121.904 73.263 184.586 106.535 61.316 32.547 125.203 59.858 189.826 85.084 62.079 24.232 124.596 48.844 188.122 69.044 107.297 34.118 234.493 53.236 339.653 1.179 43.97-21.765 76.612-57.366 102.855-98.164 31.872-49.55 53.216-99.858 61.188-158.435 3.473-25.506 6.488-50.79 12.161-75.94.94-4.173 7.989-3.155 7.487 1.167-6.207 53.457-4.487 108.895-22.871 160.207-16.712 46.643-43.888 93.945-76.268 131.501-69.122 80.165-181.041 100.893-282.241 92.363-56.917-4.796-112.651-18.647-166.644-36.921-64.168-21.717-127.752-46.146-190.67-71.237-63.491-25.32-126.197-52.942-186.296-85.591-62.458-33.932-123.266-71.186-184.427-107.385-230.274-136.297-458.495-277.53-695.803-401.445-90.432-47.221-183.733-90.478-282.085-118.487-94.468-26.902-195.969-39.402-292.36-14.92-109.026 27.689-208.23 93.149-267.54 189.714-34.61 56.349-48.227 117.554-56.037 182.523-3.29 27.336-6.748 54.951-4.988 82.531 1.857 29.084 30.713 126.963 24.935 149.836-1.784 7.06-13.86 5.453-12.854-2.003 3.563-26.396-30.271-126.72-31.684-153.311-1.522-28.73 1.888-57.602 4.979-86.12 3.293-30.388 7.431-60.842 15.056-90.482 27.794-108.065 111.129-198.867 208.373-250.149z"
        />
        <linearGradient
          id="ad"
          x1={-1146.311}
          x2={-1740.895}
          y1={2445.771}
          y2={2656.352}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#311944",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#893976",
            }}
          />
        </linearGradient>
        <path
          fill="url(#ad)"
          d="m2717.182 2774.232-239.971 39.103a63.55 63.55 0 0 1-15.192.63l-19.604-1.544 3.25-426.547 271.517-9.638v397.996z"
        />
        <linearGradient
          id="ae"
          x1={-1214.714}
          x2={-1393.622}
          y1={2623.439}
          y2={2571.143}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#311944",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#893976",
            }}
          />
        </linearGradient>
        <path
          fill="url(#ae)"
          d="M2167.727 2401.566v371.496c0 13.292 10.211 24.152 23.418 24.938l259.085 15.411c10.48.623 19.423-8.08 19.423-18.882v-387.034c0-10.812-8.477-19.774-18.997-20.068l-260.952-7.272c-12.103-.338-21.977 9.271-21.977 21.411z"
        />
        <linearGradient
          id="af"
          x1={-1401.325}
          x2={-1447.167}
          y1={2243.988}
          y2={2405.525}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#311944",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#893976",
            }}
          />
        </linearGradient>
        <path
          fill="url(#af)"
          d="m2717.182 2376.236-247.53 11.72-279.949-7.802 287.015-9.35z"
        />
        <linearGradient
          id="ag"
          x1={-1170.094}
          x2={-1462.045}
          y1={2410.375}
          y2={2903.448}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#311944",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#893976",
            }}
          />
        </linearGradient>
        <path
          fill="url(#ag)"
          d="m2190.072 2380.165 204.37 5.695c11.626.323 21.118 10.13 21.105 22.008-.021 19.823-3.329 40.312-12.055 60.077-29.092 65.897-94.125 68.33-107.656 128.816-11.273 50.396 28.648 72.08 32.868 136.479 1.108 16.918-.355 35.117-5.392 54.628-2.651 10.271-12.2 17.267-22.609 16.647l-112.512-6.692c-11.544-.687-20.466-10.174-20.466-21.787v-374.1c.002-12.344 10.041-22.114 22.347-21.771z"
        />
        <linearGradient
          id="ah"
          x1={-1353.044}
          x2={-1235.553}
          y1={2413.266}
          y2={3005.153}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#ah)"
          d="m2378.841 2809.165-96.062-5.714v-420.703l96.062 2.678z"
        />
        <linearGradient
          id="ai"
          x1={-1335.23}
          x2={-1127.121}
          y1={2597.427}
          y2={2566.65}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#ai)"
          d="m2374.514 2808.907-91.735-5.456v-420.703l91.735 2.557z"
        />
        <linearGradient
          id="aj"
          x1={-1475.107}
          x2={-1033.565}
          y1={2387.146}
          y2={2321.848}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#aj)"
          d="m2548.431 2372.424-267.782 15.225h96.273l234.118-13.811z"
        />
        <linearGradient
          id="ak"
          x1={-1251.3}
          x2={-1360.701}
          y1={2263.741}
          y2={2377.518}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#ak)"
          d="M2418.13 2365.763c-6.235-38.199-10.793-66.116-35.737-91.896-10.52-10.871-22.006-22.743-40.843-25.892-21.663-3.621-49.313 4.917-56.889 22.609-7.193 16.799 9.753 27.746 2.553 47.043-7.235 19.393-28.322 18.979-30.633 34.643-1.956 13.268 10.994 28.32 24.068 35.374 22.579 12.181 35.398-4.957 79.498-2.188 30.39 1.907 47.929 11.528 56.16 1.823 3.919-4.621 3.534-11.037 1.823-21.516z"
        />
        <g opacity={0.3}>
          <linearGradient
            id="al"
            x1={-1233.683}
            x2={-1343.084}
            y1={2280.681}
            y2={2394.459}
            gradientTransform="matrix(-1 0 0 1 1014.031 0)"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#ffc444",
              }}
            />
            <stop
              offset={0.314}
              style={{
                stopColor: "#fba94a",
              }}
            />
            <stop
              offset={0.996}
              style={{
                stopColor: "#f36f56",
              }}
            />
          </linearGradient>
          <path
            fill="url(#al)"
            d="M2297.425 2350.812c27.227-10.413 41.182-33.075 53.241-27.715 10.718 4.764 4.178 24.654 16.775 40.843 11.503 14.783 32.601 18.3 51.347 18.314-.473 1.893-1.242 3.563-2.48 5.024-8.231 9.705-25.771.084-56.16-1.823-44.1-2.769-56.919 14.369-79.498 2.188-11.994-6.472-23.852-19.674-24.222-32.056 12.723 1.368 26.877.625 40.997-4.775z"
          />
        </g>
        <linearGradient
          id="am"
          x1={-1509.798}
          x2={-1219.251}
          y1={2309.097}
          y2={2266.128}
          gradientTransform="matrix(-1 0 0 1 1014.031 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#ffc444",
            }}
          />
          <stop
            offset={0.314}
            style={{
              stopColor: "#fba94a",
            }}
          />
          <stop
            offset={0.996}
            style={{
              stopColor: "#f36f56",
            }}
          />
        </linearGradient>
        <path
          fill="url(#am)"
          d="M2582.596 2271.313c-18.315-14.454-37.622 1.665-60.17-14.222-22.839-16.092-16.203-41.91-33.915-49.23-20.576-8.505-51.056 17.445-65.64 33.914-37.046 41.831-54.443 116.096-25.162 142.221 10.989 9.806 42.109 5.765 103.9-2.717 70.627-9.695 80.791-16.639 87.551-25.727 18.215-24.491 14.17-67.874-6.564-84.239z"
        />
        <g opacity={0.3}>
          <linearGradient
            id="an"
            x1={-1506.418}
            x2={-1215.871}
            y1={2331.953}
            y2={2288.985}
            gradientTransform="matrix(-1 0 0 1 1014.031 0)"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset={0}
              style={{
                stopColor: "#ffc444",
              }}
            />
            <stop
              offset={0.314}
              style={{
                stopColor: "#fba94a",
              }}
            />
            <stop
              offset={0.996}
              style={{
                stopColor: "#f36f56",
              }}
            />
          </linearGradient>
          <path
            fill="url(#an)"
            d="M2466.631 2302.676c10.179-3.211 14.815 8.438 35.737 13.127 3.84.861 40.735 8.569 60.535-14.586 7.856-9.188 11.543-21.543 11.115-34.645 2.888 1.004 5.744 2.506 8.577 4.741 20.734 16.364 24.779 59.747 6.564 84.239-6.76 9.088-16.924 16.031-87.551 25.727-61.791 8.481-92.911 12.522-103.9 2.717-1.478-1.317-2.804-2.789-4.047-4.341 14.824-.489 30.378-4.078 41.607-14.986 21.67-21.048 14.06-56.536 31.363-61.993z"
          />
        </g>
      </svg>
    </Box>
  );
}

export default memo(TareasAnualesIlustracion);
